import { Link } from "react-router-dom";
import { heroData } from "@/mocks/home";

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage:
            "url(https://readdy.ai/api/search-image?query=Dark%20dramatic%20theater%20stage%20with%20crimson%20red%20curtains%2C%20empty%20stage%20with%20single%20spotlight%2C%20deep%20black%20and%20dark%20red%20cinematic%20color%20grade%2C%20mysterious%20atmosphere%2C%20theatrical%20lighting%2C%20fine%20art%20photography%2C%20dramatic%20shadows%2C%20professional%20color%20grade%2C%20luxurious%20velvet%20texture%2C%20high%20contrast%20noir%20aesthetic&width=1920&height=1080&seq=hero-bg-main&orientation=landscape)",
        }}
      ></div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/70"></div>

      <div className="relative z-10 w-full px-4 md:px-6 flex flex-col items-center justify-center text-center pt-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-foreground-50 leading-tight mb-6">
            {heroData.tagline}
          </h1>
          <p className="text-base md:text-lg text-foreground-300 mb-10 max-w-2xl mx-auto leading-relaxed">
            {heroData.subtitle}
          </p>
          <Link
            to="/category/wanghong-tafang"
            className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500/90 hover:bg-primary-500 text-foreground-50 font-medium rounded-full text-base transition-all duration-300 hover:scale-105"
          >
            {heroData.ctaText}
          </Link>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 w-full pb-8 md:pb-12 z-10">
        <p className="text-4xl md:text-6xl lg:text-8xl font-heading font-black text-foreground-50/10 text-center whitespace-nowrap px-4 select-none">
          在线吃瓜官网
        </p>
      </div>
    </section>
  );
}